export default __webpack_public_path__ + "static/media/Knife&Scissors.bfa507dd.png";